import { Box } from 'components/elements'
import { CSS } from 'theme'
import { ShimmerCss } from '.'

interface GalleryShimmerProps {
  css?: CSS
}

export const GalleryShimmer = ({ css }: GalleryShimmerProps) => {
  return (
    <Box
      css={{
        ...ShimmerCss,
        ...ImageItemCss,
        mr: '$space$10',
        borderRadius: '$sm',
        ...css,
      }}
    ></Box>
  )
}

const ImageItemCss = {
  width: 351,
  height: 200,
}
